var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"courseContent",staticClass:"fill fill-grey mt-24"},[[_c('h2',{staticClass:"text-rothek font-36 mb-20 mt-20"},[(!_vm.course.enroll)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('course.content'))}})]:[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('course.structureAndProgress'))}})]],2),_c('module-list')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }